'use client'

import { findStoreByLocaleOrPrefix } from '../../domain/store'
import useCurrentLocale from './useCurrentLocale'

export default function useCurrentStore() {
  const locale = useCurrentLocale()
  return findStoreByLocaleOrPrefix(locale)
}
